import { type FC } from "react";

import { type ValueInspectorRowInfo } from "../traverseValue/ValueInspectorRowInfo";
import { type ValuePathSlice, joinPath } from "../traverseValue/ValuePath";
import { stringifyValueName } from "./stringifyValueName";

/**
 * Displays the identifier for a value inside the inspector. For example, a
 * cell's name, the key for a field in an object, an array index, or a key in a
 * map.
 */
export const ValueName: FC<{
	cellID: string;
	row: ValueInspectorRowInfo;
}> = ({ row }) => {
	const isEditable = true; //useAppSelector(selectCanvasWritable);

	const lastComponent = row.path[row.path.length - 1]!;

	if (!isEditable) {
		return (
			<span className="bg-tertiary text-syntax-key  rounded px-1">
				{stringifyValueName(lastComponent)}
			</span>
		);
	}

	return <>{stringifyValueName(lastComponent)}</>;
};
